exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".info-main[data-v-0cedb930]{padding:0 .32rem}.sub_t[data-v-0cedb930]{font-size:.18rem;font-weight:bold}", ""]);

// exports
